import { useQuery } from '@tanstack/react-query';
import { getTaskListInfoParams } from './types';
import { fetchTaskList } from '../../apis/task';

function useTaskListInfo(params: getTaskListInfoParams) {
  const { patient_id } = params;

  const { data, isError, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ['task-list'],
    queryFn: () => fetchTaskList(patient_id),
  });

  return {
    isLoading: isLoading,
    isError: isError,
    isRefetching: isRefetching,
    tasks: data?.tasks,
    refetch: refetch,
  };
}

export default useTaskListInfo;
